import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AuntyOrUncleProfile from "../../../components/AskAuntyOrUncle/Profile";
import {getAuntiesRequest} from "../../../actionCreators/auntiesActions";
import {getOrganisationRequest} from "../../../actionCreators/organisationActions";

const AuntyOrUncleProfileComponent = (props) => <AuntyOrUncleProfile {...props} />;

const AuntyOrUncleProfileContainer = (props) => {
    const state = useSelector((state) => ({
        aunties: state.aunties.aunties,
        organisation: state.organisation.organisation
    }));

    const dispatch = useDispatch();

    const actions = {
        getAunties: (payload) => dispatch(getAuntiesRequest(payload)),
        getOrganisation: (payload) => dispatch(getOrganisationRequest(payload))
    };

    return <AuntyOrUncleProfileComponent {...props} {...state} {...actions} />;
};

export default AuntyOrUncleProfileContainer
